import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcIntegratedWebcam } from "react-icons/fc";
let today = new Date();
const colourCode = (date) => {
  let webinarDate = new Date(date);
  let status = webinarDate >= today ? "upcoming" : "expired";
  if (status === "upcoming") {
    return "badge bg-green text-white";
  } else if (status === "expired") {
    return "badge bg-red text-white";
  }
};
const getStatus = (date) => {
  let webinarDate = new Date(date);
  let status = webinarDate >= today ? "Upcoming" : "Expired";
  return status;
};
const ViewWebinar = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((store) => store.login.user);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/webinar/getwebinarById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting handover!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcIntegratedWebcam className="fs-2 me-1" />
                  Webinar
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Webinar Details</h2>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mb-3 m-auto text-center mt-3">
                  <img
                    src={`${data?.webinarThumbnail}`}
                    alt="Thumbnail Img"
                    height="400px"
                    width="400px"
                    className="border"
                  ></img>
                </div>
                <div className="col-12 col-md-6 col-lg-6  mb-3 mt-3">
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Date :
                      </label>
                      <div className="w-100 col">
                        {(data?.webinarDate || "N/A").toUpperCase()}
                      </div>
                    </div>
                  )}

                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Name :
                      </label>
                      <div className="w-100 col">
                        {(data?.webinarName || "N/A").toUpperCase()}
                      </div>
                    </div>
                  )}

                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Description :
                      </label>
                      <div className="w-100 col">
                        {(data?.description || "N/A").toUpperCase()}
                      </div>
                    </div>
                  )}

                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Start Time :
                      </label>
                      <div className="w-100 col">
                        {(data?.webinarStartTime || "N/A").toUpperCase()}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar End Time :
                      </label>
                      <div className="w-100 col">
                        {(data?.webinarEndTime || "N/A").toUpperCase()}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Status
                      </label>
                      <div className="w-100 col">
                        <span className={colourCode(data?.webinarDate)}>
                          {getStatus(data?.webinarDate) || "N/A"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton
                  buttonText="Edit Webinar"
                  href={`/edit-webinar/${id}`}
                />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewWebinar;
